import MainLayout from "../dashboard/main/MainLayout";
import { Routes, Route } from "react-router-dom";
import QuickSelect from "../dashboard/main/QuickSelect";
import CompanyProfile from "../dashboard/Company/CompanyProfile";
import UserProfile from "../dashboard/User/UserProfile";
import CompanyStaff from "../dashboard/management/company-staff/CompanyStaff";
import GroupDetails from "../dashboard/management/company-staff/group-details/GroupDetails";
import Items from "../dashboard/management/items/Items";
import RegisterAssembly from "../dashboard/management/items/register-new-assembly/RegisterAssembly";
import CustomerDashboard from "../dashboard/management/customers/CustomerDashboard";
import CustomerGeneralDetails from "../dashboard/management/customers/customer-details/GeneralDetails";
import SupplierDashboard from "../dashboard/management/suppliers/SupplierDashboard";
import SupplierGeneralDetails from "../dashboard/management/suppliers/supplier-details/GeneralDetails";
import AddCustomer from "../dashboard/management/customers/AddCustomer";
import AddSupplier from "../dashboard/management/suppliers/AddSupplier";
import RegisterItems from "../dashboard/management/items/register-new-item/RegisterItems";
import DetailsOfItem from "../dashboard/management/items/DetailsOfItem/DetailsOfItem";
import SchedulerDashboard from "../dashboard/management/scheduler/ScheduleDashboard";
import ScheduleJob from "../dashboard/management/scheduler/ScheduleJob";
import StatisticsDashboard from "../dashboard/management/statistics/StatisticsDashboard";
import GoodsOverview from "../dashboard/management/GoodsInOut/GoodsManagment/GoodsOverview";
import GoodsInCard from "../dashboard/management/GoodsInOut/GoodsIn/GoodsInCard";
import GoodsoutCard from "../dashboard/management/GoodsInOut/GoodsOut/GoodsoutCard";
import Warehousedashboardcards from "../dashboard/management/Warehouse/Warehousedashboard/Warehousedashboardcards";
import Picking from "../dashboard/management/PickingandPacking/PickingPacking/Picking";
import Packing from "../dashboard/management/PickingandPacking/PickingPacking/Packing";
import PickingList from "../dashboard/management/PickingandPacking/PickingPacking/PickingList";
import PicklistDetails from "../dashboard/management/PickingandPacking/PickingPacking/PicklistDetails";
import Dashboard from "../dashboard/management/GoodsInOut/Dashboard";
import DashboardPicking from "../dashboard/management/PickingandPacking/PickingPacking/DashboardPicking"
import ScheduleOrder from "../dashboard/management/scheduler/ScheduleOrder";
import EditCustomer from "../dashboard/management/customers/EditCustomer";
import EditSupplier from "../dashboard/management/suppliers/EditSupplier";
import EditItems from "../dashboard/management/items/register-new-item/EditItems"
import EditAssembly from "../dashboard/management/items/register-new-assembly/EditAssembly"
import DashboardSchedule from "../dashboard/management/scheduler/Dashboard";
import ManagementDashboard from "../dashboard/management/ManagementDashboard";
import EditScheduleJob from "../dashboard/management/scheduler/EditScheduleJob";
import SettingsDashboard from "../dashboard/Setting/SettingsDashboard";
const managementDashboard = () => (
  <>
    <Route path="/dashboard" element={<MainLayout />}>
      <Route path="/dashboard" element={<QuickSelect />} />
      <Route path="/dashboard/company-profile" element={<CompanyProfile />} />
      <Route path="/dashboard/user-profile" element={<UserProfile />} />
      <Route path="/dashboard/settings" element={<SettingsDashboard />} />

      <Route
        path="/dashboard/management/management-dashboard"
        element={<ManagementDashboard />}
      />

      {/* Company Staff */}
      <Route
        path="/dashboard/management/company-staff"
        element={<CompanyStaff />}
      />
      <Route
        path="/dashboard/management/company-staff/group-details"
        element={<GroupDetails />}
      />
      {/* Items/Assembly */}
      <Route path="/dashboard/management/items" element={<Items />} />
      <Route
        path="/dashboard/management/items/item-details"
        element={<DetailsOfItem />}
      />
      <Route
        path="/dashboard/management/items/add-item"
        element={<RegisterItems />}
      />
       <Route
        path="/dashboard/management/items/edit-item"
        element={<EditItems/>}
      />

      <Route
        path="/dashboard/management/items/add-assembly"
        element={<RegisterAssembly />}
      />
       <Route
        path="/dashboard/management/items/edit-assembly"
        element={<EditAssembly />}
      />
      
      {/* Customers */}
      <Route
        path="/dashboard/management/customer-dashboard"
        element={<CustomerDashboard />}
      />
      <Route
        path="/dashboard/management/customer-dashboard/customer-details"
        element={<CustomerGeneralDetails />}
      />
      <Route
        path="/dashboard/management/customer-dashboard/add-customer"
        element={<AddCustomer />}
      />
       <Route
        path="/dashboard/management/customer-dashboard/edit-customer"
        element={<EditCustomer />}
      />
      {/* Suppliers */}
      <Route
        path="/dashboard/management/supplier-dashboard"
        element={<SupplierDashboard />}
      />
      <Route
        path="/dashboard/management/supplier-dashboard/supplier-details"
        element={<SupplierGeneralDetails />}
      />
      <Route
        path="/dashboard/management/supplier-dashboard/add-supplier"
        element={<AddSupplier />}
      />
       <Route
        path="/dashboard/management/supplier-dashboard/edit-supplier"
        element={<EditSupplier />}
      />
      {/* Scheduler */}
      <Route
        path="/dashboard/management/scheduler-dashboard"
        element={<SchedulerDashboard />}
      />
      <Route
        path="/dashboard/management/scheduler-dashboard/schedule-job"
        element={<ScheduleJob />}
      />
      <Route
        path="/dashboard/management/scheduler-dashboard/edit-schedular-job"
        element={<EditScheduleJob />}
      />
      <Route
        path="/dashboard/management/statistics"
        element={<StatisticsDashboard />}
      />
      <Route
        path="/dashboard/management/goods-management"
        element={<Dashboard/>}
      />
      <Route path="/dashboard/management/goods-In" element={<GoodsInCard />} />
      <Route
        path="/dashboard/management/goods-out"
        element={<GoodsoutCard />}
      />
      <Route
        path="/dashboard/management/warehouse"
        element={<Warehousedashboardcards />}
      />
       <Route
        path="/dashboard/management/pickingDashboard"
        element={<DashboardPicking />}
      />
      <Route
        path="/dashboard/management/pickingList"
        element={<Picking />}
      />
      <Route
        path="/dashboard/management/packingList"
        element={<Packing />}
      />
      <Route
        path="/dashboard/management/create-picking-list"
        element={<PickingList />}
      />
      <Route
        path="/dashboard/management/PickinglistDetails"
        element={<PicklistDetails />}
      />
       <Route
        path="/dashboard/management/scheduler-dashboard/schedule-job/schedule-order"
        element={<ScheduleOrder />}
      />
       <Route
        path="/dashboard/management/schedule-order/group-user"
        element={<DashboardSchedule/>}
      />
    </Route>
  </>
);

export default managementDashboard;
